<template>
  <b-card class="mt-5">
    <b-row>
      <b-col class="col-12">
        <SearchFilter
          @handleSubmit="onHandleSubmit"
          :autoSearch="true"
          :dashboardName="dashboardName"
        />
      </b-col>
    </b-row>
    <!-- ROW 1 : BOX CHART + TABLE + TABLE (VERTICAL) | PIE CHART -->
    <b-row class="mt-2">
      <!-- LEFT SIDE : BOX CHART + 2 TABLES -->
      <b-col cols="12" lg="6">
        <b-row>
          <!-- BOX CHART -->
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal('จำนวนเรื่องร้องทุกข์ทั้งหมด', 'COMPLAINT_ALL')
                    "
                  >
                    <h2 class="">{{ total }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่อง Fasttrack ที่รับได้จากคัดกรอง</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- BOX CHART : อยู่ในธุรการกอง -->
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่องที่อยู่ในธุรการกอง',
                        'ADMIN_IN_DEPARTMENT',
                      )
                    "
                  >
                    <h2 class="">{{ totalInDepartment }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่องที่อยู่ในธุรการกอง</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <!-- BOX CHART : ส่งไปเจ้าหน้าที่แล้ว -->
          <b-col cols="12">
            <div class="card box-main mt-2">
              <div class="card-body box-sub">
                <div class="row">
                  <div
                    class="col text-center"
                    @click="
                      openModal(
                        'จำนวนเรื่องที่ส่งไปเจ้าหน้าที่แล้ว',
                        'ADMIN_SENT_OFFICER',
                      )
                    "
                  >
                    <h2 class="">{{ totalSentOfficer }}</h2>
                    <span class="card-title box-text-size"
                      >จำนวนเรื่องที่ส่งไปเจ้าหน้าที่แล้ว</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <!-- RIGHT SIDE : PIE CHART -->
      <b-col cols="12" lg="6">
        <ApexPieChart
          ref="REF_PIE_FASTTRACK_ROLE_ADMIN_OVERVIWE"
          :filter="filter"
          :issueName="'AdminPieChartComplaintOverview'"
          :titleText="'จำนวนเรื่อง Fasttrack ภายในกอง'"
        ></ApexPieChart>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <!-- TABLE 1 -->
      <b-col cols="6">
        <div class="card mt-2">
          <div class="card-body">
            <h3 class="mb-2">{{ tableTopTitle }}</h3>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableTopItems"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              @row-clicked="onCompanyRowClicked"
            ></b-table>
          </div>
        </div>
      </b-col>
      <!-- TABLE 2 -->
      <b-col cols="6">
        <div class="card mt-2">
          <div class="card-body">
            <h3 class="mb-2">{{ tableBottomTitle }}</h3>
            <b-table
              striped
              hover
              small
              responsive
              :items="tableBottomItems"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              @row-clicked="onOfficerRowClicked"
            ></b-table>
          </div>
        </div>
      </b-col>
    </b-row>
    <ModalVue
      @show="openModal"
      ref="REF_REF_FASTTRACK_ROLE_ADMIN_MODAL"
      :filter="filter"
    ></ModalVue>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BLink,
  BCard,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BTable,
} from "bootstrap-vue";

// import flatPickr from "vue-flatpickr-component";
import ApexPieChart from "./components/charts/ApexPieChart.vue";
import SearchFilter from "./components/SearchFilter.vue";

import * as userData from "@/auth/localStorageUtils.js";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as apiDepartment from "@/store/api/department/index.js";

import ModalVue from "./components/Modal.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BCardText,
    BTable,
    ApexPieChart,
    SearchFilter,
    ModalVue
  },
  props: {},
  data() {
    return {
      total: 0,
      totalInDepartment: 0,
      totalSentOfficer: 0,
      // TABLE (PLACEHOLDER DATA - WAITING FOR API)
      tableFields: [
        { key: "name", label: "หัวข้อ" },
        { key: "total", label: "จำนวน", class: "text-right" },
      ],
      tableTopTitle: "จำนวนรายชื่อบริษัท พร้อมจำนวนเรื่อง ที่ได้จากคัดกรอง",
      tableTopItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      tableBottomTitle: "จำนวนรายชื่อเจ้าหน้าที่ พร้อมจำนวนเรื่อง",
      tableBottomItems: [
        { name: "-", total: 0 },
        { name: "-", total: 0 },
        { name: "-", total: 0 },
      ],
      filter: {
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: null,
        departmentId: userData.departmentId(),
        // departmentId: 'ECC7E239-BD06-45A0-BE32-505E002F5D98',
        terminateMode: "admin",
      },
      // dashboardName: `ภาพรวมสถิติการดำเนินการเรื่องร้องทุกข์ของเจ้าหน้าที่ธุรการกอง ${userData.departmentName()}`,
      dashboardName: `ภาพรวมสถิติการดำเนินการเรื่อง Fasttrack ของเจ้าหน้าที่ธุรการกอง`,
    };
  },
  mounted() {
    // TEST
    // this.AdminChartsSummaryComplaintFromScreening();
    // this.AdminTableChartSentOfficer();
    // this.$refs.REF_PIE_FASTTRACK_ROLE_ADMIN_OVERVIWE.funcAdminPieChartComplaintOverview();
  },
  methods: {
    onHandleSubmit(submitFilter) {
      const self = this;
      console.log("onHandleSubmit .submitFilter", submitFilter);

      this.filter.startDate = submitFilter.startDate;
      this.filter.endDate = submitFilter.endDate;
      console.log("onHandleSubmit .filter", this.filter);

      this.AdminChartsSummaryComplaintFromScreening(this.filter);
      this.AdminTableChartSentOfficer(this.filter);
      this.$refs.REF_PIE_FASTTRACK_ROLE_ADMIN_OVERVIWE.funcAdminPieChartComplaintOverview(
        this.filter
      );
    },
    AdminChartsSummaryComplaintFromScreening() {
      console.log("AdminChartsSummaryComplaintFromScreening .filter", this.filter);

      apiDashboard
        .AdminChartsSummaryComplaintFromScreening(this.filter)
        .then((response) => {
          console.log("AdminChartsSummaryComplaintFromScreening .response", response);
          console.log(
            "AdminChartsSummaryComplaintFromScreening .response.data",
            response.data,
          );

          this.total = response.data.data.department[0].total ?? 0;
          this.totalInDepartment = response.data.data.inDepartment?.[0]?.total ?? 0;
          this.totalSentOfficer = response.data.data.sentOfficer?.[0]?.total ?? 0;

          // id = CompanyId ใช้ส่งเป็น TargetId ตอน drill-down
          // แถว "(ไม่พบชื่อบริษัท...)" จะได้ id = null -> rowClass/onCompanyRowClicked กันการคลิกไว้
          this.tableTopItems = response.data.data.mou.map((item) => ({
            id: item.id,
            name: item.name,
            total: item.total,
          }));
        })
        .catch((error) => {
          console.log("AdminChartsSummaryComplaintFromScreening .error", error);
        });
    },
    AdminTableChartSentOfficer() {
      console.log("AdminTableChartSentOfficer .filter", this.filter);

      apiDashboard
        .AdminTableChartSentOfficer(this.filter)
        .then((response) => {
          console.log("AdminTableChartSentOfficer .response", response);
          console.log(
            "AdminTableChartSentOfficer .response.data",
            response.data,
          );

          // id = OfficerId ใช้ส่งเป็น TargetId ตอน drill-down
          this.tableBottomItems = response.data.data.map((item) => ({
            id: item.id,
            name: item.name,
            total: item.total,
          }));
        })
        .catch((error) => {
          console.log("AdminTableChartSentOfficer .error", error);
        });
    },
    // funcGetDepartmentName() {
    //   const self = this;
    //   // //console.log"@funcGetDepartmentName self.filter", self.filter);
    //   // const id = userData.selectedAdminDepartment();
    //   // //console.log"@funcGetDepartmentName id", id);
    //   apiDepartment
    //     .getById(self.filter.departmentId)
    //     .then((response) => {
    //       // //console.log"@funcGetDepartmentName response", response);
    //       const name = response.data.data.name;
    //       if (name) {
    //         self.dashboardName = `${self.dashboardName} ${name}`;
    //       }
    //     })
    //     .catch((error) => {
    //       //console.log"error", error);
    //     });
    // },
    // funcGetSummaryComplaint() {
    //   const self = this;
    //   // //console.log"@funcGetSummaryComplaint division adminitration filter", self.filter);
    //   apiDashboard
    //     .GetBoxChart_SummaryComplaint(self.filter)
    //     .then((response) => {
    //       // //console.log"@funcGetSummaryComplaint division adminitration response", self.response);
    //       self.totalComplaint = response.data.data;
    //     })
    //     .catch((error) => {
    //       //console.log"error", error);
    //     });
    // },
    openModal(title, keyword) {
      console.log("openModal .title", title);
      console.log("openModal .keyword", keyword);

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_ADMIN_MODAL"];
      target.onSetData(title, keyword, this.filter); // send object to child
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
    // แถวที่ไม่มี id (= "(ไม่พบชื่อบริษัท...)") กดไม่ได้ ทำให้ดูจางและไม่ขึ้น pointer
    rowClass(item) {
      if (!item) return null;
      return item.id ? "cursor-pointer" : "text-muted";
    },
    // drill-down ของตาราง 1 : รายชื่อบริษัท -> เรื่องของบริษัทนั้นที่เข้ากองนี้
    onCompanyRowClicked(row) {
      if (!row || !row.id) return;

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_ADMIN_MODAL"];
      // แทรก TargetId เข้าไปใน object ที่ Modal.vue จะส่งต่อเป็น params ให้ commonTable
      // departmentId ติดไปกับ this.filter อยู่แล้ว -> SP ใช้กรองกองผู้รับ
      target.onSetData(
        `${this.tableTopTitle} : ${row.name}`,
        "ADMIN_FROM_SCREENING_COMPANY",
        {
          ...this.filter,
          TargetId: row.id,
        },
      );
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
    // drill-down ของตาราง 2 : รายชื่อเจ้าหน้าที่ -> เรื่องที่ค้างในมือเจ้าหน้าที่คนนั้น
    onOfficerRowClicked(row) {
      if (!row || !row.id) return;

      const target = this.$refs["REF_REF_FASTTRACK_ROLE_ADMIN_MODAL"];
      // departmentId ติดไปกับ this.filter อยู่แล้ว -> SP ใช้กรองกอง
      target.onSetData(
        `${this.tableBottomTitle} : ${row.name}`,
        "ADMIN_SENT_OFFICER_DETAILS",
        {
          ...this.filter,
          TargetId: row.id,
        },
      );
      target.$refs["REF_FASTTRACK_ROLE_MODAL"].show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.box-main {
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  height: 150px;
  border-top-style: solid;
  border-top-color: #bfb9f1;
  border-top-width: 20px;
  border-radius: 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.box-main:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  background-color: #f8f9fa; /* light gray highlight */
  border-top-color: red;
}
.box-sub {
  // background-color: #f2f1fc;
  background-color: whitesmoke;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.box-text-size {
  font-size: 16px !important;
}

.card-underline {
  // border-bottom-style: solid;
  border-bottom-color: black;
}

/* แถวในตารางที่คลิกเข้า drill-down ได้ */
::v-deep tr.cursor-pointer {
  cursor: pointer;
}
</style>